@if (selectedCrewPreviousAssignments) {
  <mat-card appearance="outlined" class="mb-4">
    <mat-card-header>
      <mat-card-title class="mb-3">Last Assignment</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="table-responsive">
        <table class="custom-table w-100">
          <thead>
            <tr>
              <th>Vessel</th>
              <th>From</th>
              <th>To</th>
              <th>Rank</th>
              <th>Duration</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            @for (ch of selectedCrewPreviousAssignments; track $index) {
              <tr>
                <td>
                  <a
                    [routerLink]="['/vessels/crew-change/crew-change-data-entry/', ch.id]"
                    class="text-link"
                    >
                    {{ ch.vesselName }}
                  </a>
                </td>
                <td>{{ dateTime(crewChangeFindPlan(ch, 'On Board')!.time) }}</td>
                <td>{{ dateTime(crewChangeFindPlan(ch, 'Off Board')!.time) }}</td>
                <td>{{ ch.rank }}</td>
                <td>{{ duration(ch) }}</td>
                <td>
                  @if (ch.isCancelled) {
                    <span class="status-cancelled">Cancelled</span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
}
